import { FormattedMessage } from "react-intl";
import { displayPopin } from "../../Hook/popins";
import { useResolvedMode } from "../../Hook/theme";
import { AdsBannerProps } from "./config";
import AdTile from "./AdTile";

/**
 * Family A, tokens (2d): the warm red → orange → gold gradient — the warm end
 * belongs to tokens alone now that the daily spin stays magenta-violet. Light
 * mode drops the end-stops in lightness; hues unchanged.
 */
const MODES = {
  dark: "border border-white/40 bg-gradient-to-r from-[#ff6b6b] via-[#ff8f57] to-[#ffcc4d] shadow-[0_18px_40px_rgba(255,125,64,0.35)]",
  light: "border border-white/40 bg-gradient-to-r from-[#e14b4b] via-[#e97a3f] to-[#d9a62e] shadow-[0_18px_40px_rgba(255,125,64,0.25)]",
};

function TokensBanner({ onDismiss }: AdsBannerProps) {
  const display = displayPopin();
  const mode = useResolvedMode();

  return (
    <AdTile
      testId="ad-tokens"
      onOpen={() => display("tokens")}
      onDismiss={onDismiss}
      className={MODES[mode]}
    >
      <div className="flex-1 min-w-0">
        <p className="text-[10px] uppercase tracking-[0.35em] text-white/80 truncate">
          <FormattedMessage id="ads_tokens_kicker" defaultMessage="Token boost" />
        </p>
        <h3 className="text-lg sm:text-xl font-black leading-tight text-white truncate">
          <FormattedMessage id="ads_tokens_title" defaultMessage="Reload your tokens in one tap" />
        </h3>
        <p className="text-xs text-white/90 truncate hidden sm:block">
          <FormattedMessage
            id="ads_tokens_body"
            defaultMessage="Power up your chats and gifts with instant tokens."
          />
        </p>
      </div>
      <div className="flex-none inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs sm:text-sm font-bold text-[#ff6b6b] shadow-sm whitespace-nowrap">
        <FormattedMessage id="ads_tokens_cta" defaultMessage="Get tokens" />
        <span aria-hidden>→</span>
      </div>
    </AdTile>
  );
}

export default TokensBanner;
